import * as axios from './Axios'


export const _generate_payment_link = (data) => axios.post(`admin/generate-payment-link`, data)
export const _send_sms = (data) => axios.post(`send-sms`, data)
export const _send_email = (data) => axios.post(`send-email`, data)
